import { gql } from '@nerdwallet/apollo';

export const GET_IDENTITY_QUERY = gql`
  query GetIdentity {
    identity {
      id
      identityId
    }
  }
`;

export const GET_NOTIFICATIONS_PREFERENCES_QUERY = gql`
  query GetNotificationsPreferences {
    # mobileAppIdentityProfile is needed to check if the user has ever installed the NW app
    mobileAppIdentityProfile {
      devices {
        deviceLastLogin
      }
    }
    subscriptionIdentityProfile {
      emailEnabled
      emailCreditMonitoringEnabled
      emailSpendingAlertsEnabled
      emailMarketingEnabled
      emailPersonalizedContentEnabled
      pushEnabled
      pushCreditMonitoringEnabled
      pushSpendingAlertsEnabled
      pushMarketingUpdatesEnabled
      pushPersonalizedContentEnabled
    }
  }
`;

export const UPDATE_SUBSCRIPTION_PROFILE_MUTATION = gql`
  mutation UpdateSubscriptionProfileV2(
    $subscriptionProfile: UpdateSubscriptionProfileInput!
    $identityId: String!
  ) {
    updateSubscriptionProfile(
      subscriptionProfile: $subscriptionProfile
      identityId: $identityId
    ) {
      emailEnabled
      emailCreditMonitoringEnabled
      emailSpendingAlertsEnabled
      emailMarketingEnabled
      emailPersonalizedContentEnabled
      pushEnabled
      pushCreditMonitoringEnabled
      pushSpendingAlertsEnabled
      pushMarketingUpdatesEnabled
      pushPersonalizedContentEnabled
    }
  }
`;
